import {detect as detectBrowser} from 'detect-browser';

export function detect() {
  let browserInfo = {};
  const browser = detectBrowser();

  if (browser) {
    browserInfo = {
      name: browser.name,
      version: browser.version,
      os: browser.os,
      isMacOS: browser.os.toLowerCase().includes('mac'),
      isiOS: browser.os.toLowerCase().includes('ios'),
    };
  }

  return browserInfo;
}

/**
 * @deprecated use iOS detection from 'detect-browser' package
 */
export function isiPadOS() {
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

export default {
  detect,
  isiPadOS,
};
